import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  padding: 1em;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  z-index: 250;
  &.flash {
    // animation-name: flash;
    opacity: 1;
  }
`;
const Mask = styled.div`
  background-size: cover;
  width: 100%;
  height: 100%;
  @media (max-width: 982px) {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

const MaskFlash = ({ input, target }) => {
  // console.log(target);
  const maskWrapperRef = useRef();
  const [mask, setMask] = useState();

  useEffect(() => {
    _randomizeMask();

    window.addEventListener("scroll", _handleScroll);

    return () => window.removeEventListener("scroll", _handleScroll);
  }, []);

  const _handleScroll = () => {
    if (window.pageYOffset > window.innerHeight) {
      _watch();
      window.removeEventListener("scroll", _handleScroll);
    }
  };

  const _watch = () => {
    let options = {
      // root: document.querySelector(".modules"),
      rootMargin: "0px",
      threshold: 1.0
    };

    let observer = new IntersectionObserver(_onEnterViewport, options);
    const selectors = target.split(",");
    selectors.forEach(function (selector) {
      const item = document.getElementById(selector);
      observer.observe(item);
    });
  };
  const _randomizeMask = () => {
    const rand = Math.round(Math.random() * input.length);
    // console.log(rand, input.length);
    setMask(input[rand]);
  };

  const _onEnterViewport = (entries, observer) => {
    // console.log(entries);
    // console.log(maskWrapperRef.current);
    if (!maskWrapperRef.current) return;

    maskWrapperRef.current.classList.add("flash");
    setTimeout(() => {
      maskWrapperRef.current.classList.remove("flash");
      _randomizeMask();
    }, 1000);
  };

  return (
    <Wrapper ref={maskWrapperRef}>
      {mask && (
        <Mask
          style={{
            backgroundImage: `url(${mask.asset.url})`
          }}></Mask>
      )}
    </Wrapper>
  );
};

export default MaskFlash;
